import { Paper, Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Select, MenuItem, Radio, Button } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { alert } from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";
import UserInfo from "../common/UserInfo";
import { asyncRequest } from "src/services/network";

const SalaryDialog = ({ open, onClose, onUpdate, user }) => {
  const [form, setForm] = useState({
    remark: "",
    amount: user.pointsSalary || '',
  });

  console.log(user)

  // useEffect(() => {
  //   setForm({
  //     ...form,
  //     amount: user.pointsSalary
  //   })
  // }, [user])

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数额不能为空");
    // console.log(form)
    // return;

    const { msg } = await asyncRequest({
      path: "/user/staff/pay",
      data: {
        uid: user.uid,
        ...form,
      },
    });

    alert(msg, "success");
    onUpdate();
  }

  return (
    <FormDialog title="发工资" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户">
        <UserInfo {...user} />
      </FormItem>

      {/* <FormItem title="变化">
        <RadioGroup row name="row-radio-buttons-group" value={form.type} onChange={(e) => handleIptChange("type", e.target.value)}>
          <FormControlLabel value={'PLUS'} control={<Radio />} label="增加" />
          <FormControlLabel value={'MINUS'} control={<Radio />} label="减少" />
        </RadioGroup>
      </FormItem> */}

      <FormItem title="数额">
        <TextField fullWidth type="number" placeholder="数额" autoComplete="off" id="amount" value={form.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth placeholder="备注" autoComplete="off" id="remark" value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default SalaryDialog;
